'use strict'
import {postForm} from './submit'
import {bootstrap} from '../bootstrap/bootstrap'

export function submitMailingListForm(e) {
  e.preventDefault()

  if (this.checkValidity()) {
    const request = new XMLHttpRequest()

    return postForm(this, this.action, request)
      .catch(() => showNotification(false))
      .then(() => showNotification())
  }
}

function showNotification(success = true) {
  const notification = document.querySelector('.footer .notification')
  const inputField = document.querySelector('.form--subscribe input[name="email"]')

  notification.classList.add(success ? 'success' : 'error')
  bootstrap(inputField, inputField => inputField.value = '')
}
